(() => {
  const videoContainerTransitionEnd = ($target) => {
    const $navigation = document.querySelector('.js-navigation');
    const navigationHeight = $navigation.offsetHeight;

    window.setTimeout(() => {
      const scrollTarget = $target.getBoundingClientRect().top;
      window.smoothScrollTo((window.pageYOffset + scrollTarget) - navigationHeight);
      document.querySelectorAll('.-no-height-transition').forEach(($item) => $item.classList.remove('-no-height-transition'));
    }, 600);
  };

  const closeAllProjects = () => {
    const $openProjects = document.querySelectorAll('.js-project.is-open');

    if ($openProjects !== null) {
      $openProjects.forEach(($item) => {
        const $iframe = $item.querySelector('iframe');
        const player = new Vimeo.Player($iframe);

        player.pause();
        $item.classList.remove('is-open');
        $item.querySelector('.js-project-video-wrapper').removeAttribute('style');
        $item.querySelector('.js-project-video-container').removeAttribute('style');
      });
    }
  };

  const projectClicked = (event) => {
    const $target = event.currentTarget;
    const $iframe = $target.querySelector('iframe');
    if (!$target.classList.contains('is-open')) {
      const $openElement = document.querySelector('.js-project.is-open');
      if ($openElement !== null) {
        const targetOffsetTop = $target.offsetTop;
        const openOffsetTop = $openElement.offsetTop;
        if (targetOffsetTop === openOffsetTop) {
          $openElement.classList.add('-no-height-transition');
          $target.classList.add('-no-height-transition');
        }
      }
      const $videoWrapper = $target.querySelector('.js-project-video-wrapper');
      const $videoContainer = $target.querySelector('.js-project-video-container');
      const $ratioBox = $target.querySelector('.js-project-video-ratio-box');
      const $videoCredits = $target.querySelector('.js-video-credits');
      const height = $ratioBox.offsetHeight + $videoCredits.offsetHeight;
      closeAllProjects();

      videoContainerTransitionEnd($target);

      if ($iframe.hasAttribute('data-src')) {
        $iframe.setAttribute('src', $iframe.getAttribute('data-src'));
        $iframe.removeAttribute('data-src');
      }

      $videoWrapper.style.height = `${height}px`;
      $videoContainer.style.height = `${height}px`;
      $target.classList.add('is-open');
    }
  };

  const projectClose = (event) => {
    event.stopPropagation();
    let $project = event.target.parentElement;
    while (!$project.classList.contains('js-project')) {
      $project = $project.parentElement;
    }
    closeAllProjects();
    window.setTimeout(() => {
      if (typeof $project !== typeof undefined) {
        $project.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      }
    }, 600);

    if ('pushState' in window.history) {
      window.history.pushState('', document.title, `${window.location.pathname}${window.location.search}`);
    }
  };

  const $projects = document.querySelectorAll('.js-project');
  const $projectCloseButtons = document.querySelectorAll('.js-project-close');
  $projects.forEach(($project) => $project.addEventListener('click', projectClicked));
  $projectCloseButtons.forEach(($button) => $button.addEventListener('click', projectClose));
})();
